import { InfoIcon } from "../../../svg/info-icon";

interface AnalyticCardProps {
  header: string;
  value: number;
  percentage?: number;
  textColor?: string;
  showInfoIcon?: boolean;
  infoIconTitle?: string;
}

const AnalyticCard = ({
  header,
  value,
  percentage,
  showInfoIcon,
  infoIconTitle,
}: AnalyticCardProps) => {
  const getHeaderColor = (headerText: string) => {
    switch (headerText.toLowerCase()) {
      case "authmate pending":
        return "text-[#0056D6]"; // Tertiary Blue 4
      case "authorized":
        return "text-[#008367]"; // Green for approved
      case "denied":
        return "text-[#DE350B]"; // Red for denied
      default:
        return "text-black"; // Default black
    }
  };

  return (
    <div className="analytic-card flex h-28 w-full flex-col items-start justify-center gap-2 rounded-md border-2 border-primaryGray-15 p-3">
      <div className="header-container flex w-full items-center gap-2">
        <div className="truncate">{header}</div>
        {showInfoIcon && (
          <div className="icon-container hover:scale-110" title={infoIconTitle}>
            <InfoIcon stroke="#8A8A8A" />
          </div>
        )}
      </div>
      <div className="flex w-full items-end gap-2">
        <div
          className={`truncate text-5xl font-bold ${getHeaderColor(header)}`}
        >
          {value}
        </div>
        {percentage && percentage > 0 ? (
          <div className="flex-shrink-0 text-sm text-primaryGray-9">
            {percentage}%
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AnalyticCard;
